/** Local draft of a recipe-count dictate session so a bad network does not drop it. */

export const RECIPE_COUNT_DRAFT_VERSION = 1 as const;

export type RecipeCountDraftLine = {
  key: string;
  recipe_id: string | null;
  recipe_name: string;
  qty: string;
  unit_cost: string;
  match: "exact" | "likely" | "unmatched";
};

export type RecipeCountOfflineDraft = {
  version: typeof RECIPE_COUNT_DRAFT_VERSION;
  saved_at: string;
  organization_id: string;
  lines: RecipeCountDraftLine[];
};

function storageKey(organizationId: string): string {
  return `mfg:recipe-count-draft:v1:${organizationId}`;
}

export function saveRecipeCountOfflineDraft(draft: RecipeCountOfflineDraft): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.setItem(storageKey(draft.organization_id), JSON.stringify(draft));
  } catch {
    // quota / private mode
  }
}

export function loadRecipeCountOfflineDraft(
  organizationId: string,
): RecipeCountOfflineDraft | null {
  if (typeof localStorage === "undefined") return null;
  try {
    const raw = localStorage.getItem(storageKey(organizationId));
    if (!raw) return null;
    const parsed = JSON.parse(raw) as RecipeCountOfflineDraft;
    if (parsed?.version !== RECIPE_COUNT_DRAFT_VERSION || !Array.isArray(parsed.lines)) {
      return null;
    }
    return parsed;
  } catch {
    return null;
  }
}

export function clearRecipeCountOfflineDraft(organizationId: string): void {
  if (typeof localStorage === "undefined") return;
  try {
    localStorage.removeItem(storageKey(organizationId));
  } catch {
    // ignore
  }
}
